<template>
  <el-container class="tui-content" style="display: block;">
    <el-row  class="tui-el">
      <el-col :span="6">功能选择</el-col>
       
    </el-row>
    <el-row  class="tui-el"  style="margin-top: 20px;">
      <el-col :span="8">
        <el-select v-model="value"  filterable placeholder="请选择" @change="onChangeStripe">
            <el-option
              v-for="item in options"
              :key="item.label"
              :label="item.label"

              :value="item.value">
            </el-option>
          </el-select>

      </el-col>

      <el-col :span="16" style="border: 1px solid #c6c6c6;height: 850px;overflow-y:scroll;width: 40%;">


        <el-row style="margin-left: 50px;margin-top: 20px;">
          <template >
            <el-checkbox v-model="checked1" size="5" border='true' @change="checked=>checks(checked, 'x1')">X1</el-checkbox>
          </template>
        </el-row>
        <el-row  style="margin-left: 50px;margin-top: 20px;">
          <template>
            <el-checkbox v-model="checked2" size="5" border='true' @change="checked=>checks(checked, 'x2')">X2</el-checkbox>
          </template>
        </el-row>
        <el-row  style="margin-left: 50px;margin-top: 20px;">
          <template>
            <el-checkbox v-model="checked3" size="5" border='true' @change="checked=>checks(checked, 'a1')">A1</el-checkbox>
          </template>
        </el-row>
        <el-row  style="margin-left: 50px;margin-top: 20px;">
          <template>
            <el-checkbox v-model="checked4" size="5" border='true' @change="checked=>checks(checked, 'a2')">A2</el-checkbox>
          </template>
        </el-row>
        <el-row  style="margin-left: 50px;margin-top: 20px;">
          <template>
            <el-checkbox v-model="checked5" size="5" border='true' @change="checked=>checks(checked, 'k1')">K1</el-checkbox>
          </template>
        </el-row>
        <el-row  style="margin-left: 50px;margin-top: 20px;">
          <template>
            <el-checkbox v-model="checked6" size="5" border='true' @change="checked=>checks(checked, 'k2')">K2</el-checkbox>
          </template>
        </el-row>
        <el-row  style="margin-left: 50px;margin-top: 20px;">
          <template>
            <el-checkbox v-model="checked7" size="5" border='true' @change="checked=>checks(checked, 'g')">G</el-checkbox>
          </template>
        </el-row>
        <el-row  style="margin-left: 50px;margin-top: 20px;">
          <template>
            <el-checkbox v-model="checked8" size="5" border='true' @change="checked=>checks(checked, 's')">S</el-checkbox>
          </template>
        </el-row>
        <el-row  style="margin-left: 50px;margin-top: 20px;">
          <template>
            <el-checkbox v-model="checked9" size="5" border='true' @change="checked=>checks(checked, 'i')">I</el-checkbox>
          </template>
        </el-row>

      </el-col>


    </el-row>

  </el-container>
</template>

<script>

  export default {
    data() {
       return {
        options: [],
        value:'',
        checked1:false,
        checked2:false,
        checked3:false,
        checked4:false,
        checked5:false,
        checked6:false,
        checked7:false,
        checked8:false,
        checked9:false,
        list:{'x1':false,'x2':false,'a1':false,'a2':false,'k1':false,'k2':false,'g':false,'s':false,'i':false}
      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();
    },

	methods:{
    checks(val,t){
      var a = 0
      if(val){
        a = 1
      }
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.newName == ''){
        this.msg('请填写名称','error')
        return false
      }

      axiosInstance({
      	method:'post',
      	url:'http://y31p.yoooooo.com/index.php/index/data/acjAdd',
      	params:{
      		a:a,
          t:t,
          l_id:this.value
      	}
      })
      .then(res=>{
        this.$message({
        	type: 'success',
        	message: '修改成功'
        });

      })
      .catch(err=>{

      });
    },
    onChangeStripe(){
      this.loadList()
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{

    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/pythonImgList'
    	})
    	.then(res=>{
    		this.options = res.data;
        this.value = this.options[0]['value']
        this.loadList()
    	})
    	.catch(err=>{

    	});
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          l_id:this.value

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/acjList'
      })
      .then(res=>{
        if(res.data){
          this.list = res.data
        }else{
          this.list = {'x1':false,'x2':false,'a1':false,'a2':false,'k1':false,'k2':false,'g':false,'s':false,'i':false}
        }

        this.checked1 = this.list['x1'] == 1?true:false
        this.checked2 = this.list['x2'] == 1?true:false
        this.checked3 = this.list['a1'] == 1?true:false
        this.checked4 = this.list['a2'] == 1?true:false
        this.checked5 = this.list['k1'] == 1?true:false
        this.checked6 = this.list['k2'] == 1?true:false
        this.checked7 = this.list['g'] == 1?true:false
        this.checked8 = this.list['s'] == 1?true:false
        this.checked9 = this.list['i'] == 1?true:false

      })
      .catch(err=>{

      });
    },

    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .tui-content{
    margin-left: 24%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }
  .tui-el{
    width: 80%;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/acj.vue